import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class DirectorCautionReactiveStatusModel extends Model {
    constructor(
      public tabSwitch: boolean = true,
      public shortKey: boolean = true,
      public multiMonitor: boolean = true
    ) {
        super();
    }

    public static create(model: Partial<DirectorCautionReactiveStatusModel>): DirectorCautionReactiveStatusModel {
        return createModel<DirectorCautionReactiveStatusModel>(DirectorCautionReactiveStatusModel, {
            ...model
        });
    }
}